import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import DynamicFiltersBar from 'components/DynamicFiltersBar';
import DistanceDropdown, { DISTANCE_TITLE } from 'components/DistanceDropdown';
import ProviderSpecialtyDropdown, { SPECIALTIES_TITLE } from 'components/ProviderSpecialtyDropdown';
import RatingDropdown, { RATING_TITLE } from 'components/RatingDropdown';
import VerifiedDropdown, { VERIFIED_TITLE } from 'components/VerifiedDropdown';
import GenderDropdown, { GENDER_TITLE } from 'components/GenderDropdown';
import LanguageDropdown, { LANGUAGE_TITLE } from 'components/LanguageDropdown';
import ConfidenceDropdown, { CONFIDENCE_TITLE } from 'components/ConfidenceDropdown';
import NetworkDropdown, { NETWORK_TITLE } from 'components/NetworkDropdown';
var distanceTooltipText = 'Enter Location details to enable Distance filter';
var ProvidersFilters = function (_a) {
    var _b = _a.filterValues, filterValues = _b === void 0 ? {} : _b, _c = _a.planTiers, planTiers = _c === void 0 ? [] : _c, filtersUpdate = _a.filtersUpdate, filtersUpdateSeveral = _a.filtersUpdateSeveral, _d = _a.onResetFilters, onResetFilters = _d === void 0 ? function () { } : _d, requestType = _a.requestType;
    var _e = useState(Date.now() + 1), distanceResetKey = _e[0], setDistanceResetKey = _e[1];
    var _f = useState(!!filterValues.distance), shouldResetDistance = _f[0], setShouldResetDistance = _f[1];
    var _g = useState(false), isNetworkEnabled = _g[0], setIsNetworkEnabled = _g[1];
    var isAddressEntered = !!filterValues.address;
    var resetDistance = function () {
        filtersUpdate('distance', 20);
        setDistanceResetKey(Date.now());
    };
    useEffect(function () {
        if (!filterValues.address && filterValues.distance) {
            resetDistance();
        }
        setShouldResetDistance(false);
        // eslint-disable-next-line
    }, [shouldResetDistance, JSON.stringify(filterValues)]);
    useEffect(function () {
        var hasValidTier = planTiers && planTiers.find(function (i) { return !!i.uuid; });
        setIsNetworkEnabled(!!hasValidTier);
    }, [planTiers]);
    var verifiedDefaultValue = {
        verified_after: filterValues.verified_after,
        is_verified: filterValues.is_verified
    };
    var elements = {
        distance: {
            name: DISTANCE_TITLE,
            element: (_jsx(Tooltip, { placement: "bottomLeft", title: !isAddressEntered ? distanceTooltipText : '', children: _jsx("div", { children: _jsx(DistanceDropdown, { disabled: !isAddressEntered, onSave: function (value) {
                            filtersUpdate('distance', value);
                        }, defaultValue: filterValues.distance, dataTest: "providersPageDistanceFilter" }) }, distanceResetKey) }))
        },
        specialties_uuids: {
            name: SPECIALTIES_TITLE,
            element: (_jsx(ProviderSpecialtyDropdown, { onSave: function (selectedItems) {
                    return filtersUpdate('specialties_uuids', (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) ? JSON.stringify(selectedItems) : undefined);
                }, requestType: requestType, defaultValue: filterValues.specialties_uuids
                    ? JSON.parse(filterValues.specialties_uuids)
                    : undefined, dataTest: "providersPageTypeFilter" }))
        },
        min_rating: {
            name: RATING_TITLE,
            element: (_jsx(RatingDropdown, { onSave: function (value) {
                    filtersUpdate('min_rating', value);
                }, defaultValue: filterValues.min_rating, dataTest: "providersPageRatingFilter" }))
        },
        is_verified: {
            name: VERIFIED_TITLE,
            element: (_jsx(VerifiedDropdown, { defaultValue: verifiedDefaultValue, filtersUpdateSeveral: filtersUpdateSeveral, dataTest: "providersPageVerifiedFilter" }))
        },
        gender: {
            name: GENDER_TITLE,
            element: (_jsx(GenderDropdown, { onSelect: function (value) {
                    filtersUpdate('gender', value !== 'any' ? value : undefined);
                }, defaultValue: filterValues.gender, dataTest: "providersPageGenderFilter" }))
        },
        language: {
            name: LANGUAGE_TITLE,
            element: (_jsx(LanguageDropdown, { onSave: function (value) { return filtersUpdate('language', value); }, defaultValue: filterValues.language, dataTest: "providersPageLanguageFilter" }))
        },
        min_confidence: {
            name: CONFIDENCE_TITLE,
            element: (_jsx(ConfidenceDropdown, { onSelect: function (value) { return filtersUpdate('min_confidence', value); }, defaultValue: filterValues.min_confidence, dataTest: "providersPageConfidenceFilter" }))
        },
        insurance_plan_tiers: {
            name: NETWORK_TITLE,
            element: (_jsx(NetworkDropdown, { planId: filterValues.plan_id, onSave: function (selectedItems) {
                    filtersUpdate('insurance_plan_tiers', (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) ? JSON.stringify(selectedItems) : undefined);
                }, defaultValue: filterValues.insurance_plan_tiers
                    ? JSON.parse(filterValues.insurance_plan_tiers)
                    : undefined, disabled: !isNetworkEnabled || !filterValues.plan_id, dataTest: "providersPageNetworkFilter" }))
        }
    };
    return (_jsx(DynamicFiltersBar, { elements: elements, filterValues: filterValues, resetFilters: onResetFilters, defaultActiveKeys: [
            'distance',
            'specialties_uuids',
            'min_rating',
            'min_confidence'
        ] }));
};
export default ProvidersFilters;
